import apiClient from "@/utils/httpClient";
import type {
  CreateViewRequest,
  UpdateViewRequest,
  ViewSummary,
  ViewDetail,
  ShareViewRequest,
} from "@blinkbooks/types";

export const createView = async (data: CreateViewRequest): Promise<{ id: string; name: string }> => {
  return apiClient.post<{ id: string; name: string }>("/views", data);
};

export const listViews = async (): Promise<ViewSummary[]> => {
  return apiClient.get<ViewSummary[]>("/views");
};

export const getView = async (id: string): Promise<ViewDetail> => {
  return apiClient.get<ViewDetail>(`/views/${id}`);
};

export const updateView = async (id: string, data: UpdateViewRequest): Promise<{ id: string; name: string }> => {
  return apiClient.patch<{ id: string; name: string }>(`/views/${id}`, data);
};

export const deleteView = async (id: string): Promise<void> => {
  await apiClient.delete(`/views/${id}`);
};

export const shareView = async (id: string, data: ShareViewRequest): Promise<{ shared: boolean; pending: boolean }> => {
  return apiClient.post<{ shared: boolean; pending: boolean }>(`/views/${id}/share`, data);
};

export const revokeViewShare = async (id: string, userId: string): Promise<void> => {
  await apiClient.delete(`/views/${id}/share/${userId}`);
};

export const getViewInviteInfo = async (token: string): Promise<{ viewName: string; email: string }> => {
  return apiClient.get<{ viewName: string; email: string }>("/views/invite-info", { token });
};

export const acceptViewInvite = async (
  token: string,
  newUserData?: { firstName: string; lastName: string; password: string }
): Promise<{ userId: string; viewId: string }> => {
  return apiClient.post<{ userId: string; viewId: string }>("/views/accept-invite", { token, ...newUserData });
};
